import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

import ProductGridItem from '../components/ProductGridItem';
import SearchForm from '../components/search/SearchForm';

export default class StaticSearch {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.$searchField = this.$el.find('[data-live-search]');

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(
        new ProductGridItem({
          el: productItem,
          id: this.section.id,
        }),
      );
    });

    this._updatePrices();
    this.searchForm = new SearchForm(this.$searchField);
  }

  onSectionUnload() {
    this.searchForm.unload();

    this.productItems.forEach(productItem => {
      productItem.unload();
    });
  }

  _updatePrices() {
    this.$el.find('.money:not([data-currency]').each((index, el) => CurrencyConverter.update(el));
  }
}
